var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.001 512.001",
    height: "100%",
    viewBox: "0 0 512.001 512.001",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m511.161 391.757-25.162-72.017c17.033-29.781 26.001-63.523 26.001-98.049 0-109.031-88.704-197.735-197.735-197.735-59.705 0-114.962 26.135-152.534 71.915-91.899 16.976-161.731 97.702-161.731 194.44 0 34.525 8.969 68.268 26.001 98.05l-25.161 72.016c-1.774 5.078-.693 10.718 2.833 14.78 3.526 4.063 8.958 5.923 14.236 4.882l84.184-16.642c29.172 16.143 62.111 24.647 95.642 24.647 61.162 0 115.923-27.916 152.222-71.671 20.699-3.971 41.611-11.5 59.941-21.598l84.193 16.643c5.277 1.05 10.709-.818 14.236-4.882 3.527-4.061 4.608-9.701 2.834-14.779zm-313.426 66.288c-30.104 0-59.636-8.075-85.403-23.352-2.331-1.383-4.976-2.098-7.65-2.098-.97 0-1.945.094-2.909.285l-63.967 12.645 18.827-53.883c1.497-4.284.974-9.017-1.424-12.87-16.491-26.511-25.209-57.101-25.209-88.461 0-92.489 75.246-167.735 167.735-167.735s167.735 75.246 167.735 167.735-75.246 167.734-167.735 167.734zm257.632-135.022 18.827 53.883-63.967-12.645c-3.621-.72-7.382-.071-10.559 1.812-7.731 4.584-16.097 8.62-24.778 12 13.162-26.46 20.58-56.259 20.58-87.762 0-105.993-83.831-192.765-188.671-197.519 29.763-24.976 67.427-38.836 107.466-38.836 92.49-.001 167.735 75.246 167.735 167.735 0 31.361-8.717 61.951-25.209 88.461-2.398 3.854-2.921 8.587-1.424 12.871z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.14 253.742c-8.284 0-15 6.716-15 15v43.139c0 8.284 6.716 15 15 15s15-6.716 15-15v-43.139c0-8.285-6.715-15-15-15z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.438 222.23c-8.284 0-15 6.716-15 15v106.161c0 8.284 6.716 15 15 15s15-6.716 15-15v-106.161c0-8.284-6.716-15-15-15z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.735 253.742c-8.284 0-15 6.716-15 15v43.139c0 8.284 6.716 15 15 15s15-6.716 15-15v-43.139c0-8.285-6.716-15-15-15z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.033 237.118c-8.284 0-15 6.716-15 15v76.386c0 8.284 6.716 15 15 15s15-6.716 15-15v-76.386c0-8.285-6.716-15-15-15z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.329 265.689c-8.284 0-15 6.716-15 15v19.243c0 8.284 6.716 15 15 15s15-6.716 15-15v-19.243c0-8.284-6.715-15-15-15z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.372d8a93.svg";
export { ForwardRef as ReactComponent };